import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "~/lib/utils";

const labelVariants = cva(
	"text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

function Label({
	className,
	children,
	htmlFor,
	...props
}: Omit<React.ComponentProps<"label">, "htmlFor"> &
	VariantProps<typeof labelVariants> & { htmlFor?: string }) {
	return (
		<label
			data-slot="label"
			htmlFor={htmlFor}
			className={cn(labelVariants(), className)}
			{...props}
		>
			{children}
		</label>
	);
}

export { Label };
